import { Copy } from "lucide-react";
import { Tooltip } from "@/components/Tooltip";
import { useCopyToClipboard } from "../../hooks/useCopyToClipboard";

interface CopyButtonProps {
  value: string;
}

export const CopyButton = ({ value }: CopyButtonProps) => {
  const { isCopied, isTooltipOpen, setIsTooltipOpen, handleCopy } = useCopyToClipboard();

  const label = isCopied ? "Copied!" : "Copy to clipboard";

  return (
    <Tooltip asChild label={label} cursor="pointer" open={isTooltipOpen} onOpenChange={setIsTooltipOpen} side="bottom">
      <button
        className="ml-2 pt-2 opacity-0 transition-opacity duration-200 group-hover:opacity-100"
        onClick={() => handleCopy(value)}
        aria-label={label}
      >
        <Copy className="h-4 w-4" />
      </button>
    </Tooltip>
  );
};
